"use client"

import {
    Box, Button,
    Container, Modal, Stack,
    Typography, useMediaQuery
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import '../../assets/styles/scss/_userDeal.scss'
import DealCard from "./DealCard"
import InfoIcon from '@mui/icons-material/Info';
import ScrollableChips from "./ScrollableChips";
import DynoLoader from "../DynoLoader";
import RegisterationForm from "./RegisterationForm";
import {useEffect, useState} from "react";
import img1 from "../../assets/img/how_to_get_deal/s1.jpg";
import img2 from "../../assets/img/how_to_get_deal/s2.jpg";
import img3 from "../../assets/img/how_to_get_deal/s3.jpg";

export default function DealsView(
    {
        resultType,
        inputValue,
        deals,
        user,
        deleteDeal,
        categories,
        selectedNav,
        setSelectedNav,
        setQuestionaireModal,
        updateRecommendation,
        totalActivePromotions,
        totalCount,
        isLoading,
        onViewMore,
        isDealLoading,
        hasMoreDeals,
        questions,
        questionaireModal
    }) {

    const [openModal, setOpenModal] = useState(false);
    const [currentStep, setCurrentStep] = useState(1);
    const [selectedDeal, setSelectedDeal] = useState(null);
    const [dontShowAgain, setDontShowAgain] = useState(false);
    const isMobile = useMediaQuery('(max-width:1023px)');


    useEffect(() => {
        // Check if user has set the preference to not show modal
        const modalPreference = localStorage.getItem('dealModalPreference');
        setDontShowAgain(modalPreference === 'true');
    }, []);

    const steps = [
        {
            type: 'form'
        },
        {
            image: img1,
            description: "Step 1: Welcome to our exclusive deal! Click next to learn more.",
            type: 'image'
        },
        {
            image: img2,
            description: "Step 2: This amazing offer is only available for a limited time!",
            type: 'image'
        },
        {
            image: img3,
            description: "Step 3: Ready to get your deal? Click next to proceed!",
            type: 'image'
        }
    ];

    const handleNext = () => {
        if (currentStep < steps.length) {
            setCurrentStep(currentStep + 1);
        } else {
            resetModal()
            if (dontShowAgain) {
                localStorage.setItem('dealModalPreference', 'true');
            }
            window.open(selectedDeal?.url, '_blank', 'noopener,noreferrer');
        }
    };

    function resetModal() {
        setCurrentStep(1)
        setOpenModal(false)
    }

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: isMobile ? 360 : 550,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: isMobile ? 1 : 2,
        borderRadius: 2,
    };

    return (
        <Container sx={{width: "100%", maxWidth: "100%!important"}}>
            <div className="deals-header">
                {resultType !== "search" ? "Deals for You" : `Search Results for "${inputValue}"`}
            </div>

            {resultType !== "search" && (
                <ScrollableChips
                    categories={categories}
                    selectedNav={selectedNav}
                    setSelectedNav={setSelectedNav}
                />
            )}

            {!!totalActivePromotions && !isLoading && (
                <div
                    className="deals-info-alert d-flex align-items-center"
                    style={{fontFamily: "inherit"}}
                >
                    <InfoIcon className="deals-info-alert__icon"/>
                    <div>
                        We picked {totalCount.toLocaleString()} promotions curated only
                        for you out of {totalActivePromotions.toLocaleString()} total
                        active promotions.
                    </div>
                </div>
            )}

            {!isLoading && deals && !deals.length && (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        mt: 15,
                    }}
                >
                    <Typography variant="h3" color="textSecondary">
                        Deals not found
                    </Typography>
                </Box>
            )}

            <Grid container spacing={2}>
                {deals && deals.map((deal, index) => (
                    <DealCard
                        key={index}
                        deal={deal}
                        categories={categories}
                        setQuestionaireModal={setQuestionaireModal}
                        user={user}
                        updateRecommendation={updateRecommendation}
                        deleteDeal={deleteDeal}
                        setOpenModal={setOpenModal}
                        setSelectedDeal={setSelectedDeal}
                    />
                ))}
            </Grid>

            {isDealLoading ? (
                <DynoLoader
                    height="300px"
                    width="100%"
                    justifyContent="center"
                    alignItems="center"
                />
            ) : (
                !!hasMoreDeals ? (
                    <div className="view-more-container">
                        <button
                            onClick={onViewMore}
                            disabled={isDealLoading}
                            className="btn btn-primary view-more-button"
                        >
                            {isDealLoading ? "Loading..." : "View More Deals"}
                        </button>
                    </div>
                ) : (!user && <RegisterationForm
                    questions={questions}
                    hasDeals={deals && !!deals.length}
                />)
            )}

            <Modal
                open={openModal}
                onClose={() => resetModal()}
                aria-labelledby="deal-guide-modal"
            >
                <Box sx={modalStyle}>
                    <Stack spacing={1} alignItems="center">
                        {
                            steps[currentStep - 1].type === 'form' ?
                                (
                                    <RegisterationForm
                                        questions={questions}
                                        hasDeals={deals && !!deals.length}
                                        buttonColor="#5E60CE"
                                        setCurrentStep={setCurrentStep}
                                        currentStep={currentStep}
                                    />
                                )
                                :
                                (
                                    <>
                                        <img
                                            src={steps[currentStep - 1].image.src}
                                            alt={`Step ${currentStep}`}
                                            style={{
                                                width: isMobile ? '350px' : '100%',
                                                height: isMobile ? '250px' : '350px',
                                                borderRadius: '8px'
                                            }}
                                        />
                                        <Typography variant="h6" textAlign="center" className="mb-1 mt-3">
                                            {steps[currentStep - 1].description}
                                        </Typography>
                                    </>
                                )}
                        <Box
                            style={{marginBottom: '10px'}}
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                            }}
                        >
                            <input
                                type="checkbox"
                                id="dontShowAgain"
                                checked={dontShowAgain}
                                onChange={(e) => setDontShowAgain(e.target.checked)}
                                style={{marginRight: '8px'}}
                            />
                            <label htmlFor="dontShowAgain" style={{fontSize: '14px'}}>
                                Don't show this message again
                            </label>
                        </Box>
                        <Button
                            variant="contained"
                            onClick={handleNext}
                            sx={{
                                backgroundColor: "var(--theme-dark)",
                                "&:hover": {
                                    backgroundColor: "var(--second-color)"
                                }
                            }}
                        >
                            {currentStep === steps.length ? "Get Deal" : "Next"}
                        </Button>
                    </Stack>
                </Box>
            </Modal>
        </Container>
    );
}
